import { defineComponent as _defineComponent } from 'vue'
import FormatDateActionFields from '@/components/format-edit/FormatDateActionFields.vue'
import { useShibouDoukishoFormatData } from '@/composables/format-edit/useShibouDoukishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShibouDoukishoCreateDateCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useShibouDoukishoFormatData()

return { __sfc: true,formatData, FormatDateActionFields }
}

})